export default __webpack_public_path__ + "static/media/exhaustingtraps.093658ac.png";